/** Tipos do módulo Lançamentos mobile */

export type LancStatus = 'ok' | 'pending';

export interface Lancamento {
  id: string;
  /** Nome do fornecedor / credor */
  forn: string;
  /** CNPJ formatado */
  cnpj: string;
  /** Categoria da despesa */
  cat: string;
  /** Data formatada p/ exibição: "12/05" */
  date: string;
  /** Data completa de emissão: "27/05/2026" */
  emissao: string;
  /** Data de vencimento: "10/06/2026" */
  venc: string;
  /** Forma de pagamento: "Transferência (PIX)" */
  pgto: string;
  /** Valor em centavos como número */
  val: number;
  status: LancStatus;
  /** Se o lançamento foi digitalizado via OCR */
  ocr: boolean;
  /** URL ou dataURL da captura (se disponível) */
  shot?: string;
}

export interface LancFilters {
  tipo: 'todos' | 'ok' | 'pending';
  cat: string; // "todas" = sem filtro
  periodo: 'mes' | 'tri' | 'ano';
}

export const LANCFILTERS_DEFAULT: LancFilters = {
  tipo: 'todos',
  cat: 'todas',
  periodo: 'mes',
};
